import { useTranslation } from '@mint-lib/i18n';

import NoData from '../../atoms/NoData/NoData.jsx';

const NoResultsOverlay = () => {
  const { t } = useTranslation('@myn/permissions');
  return (
    <NoData
      header={t('No results found')}
      message={t('Try adjusting your search.')}
    />
  );
};

export default NoResultsOverlay;
